// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ss-2";
export var container = "_ss-4";
export var dismissButton = "_ss-3";
export var hasPaddingBottom = "_ss-6";
export var last = "_ss-e";
export var scrollbarThumb = "_ss-c";
export var scrollbarTrack = "_ss-b";
export var selected = "_ss-9";
export var spin = "_ss-1";
export var spinning = "_ss-0";
export var suggestionItem = "_ss-d";
export var suggestionsPanel = "_ss-5";
export var tonePill = "_ss-8";
export var tonesContainer = "_ss-7";
export var unselected = "_ss-a";